import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import polishing from "Assets/Image/News/news-publish.png";
import HeroHeading from "Components/HeroHeading";
// Import CSS module
import styles from "./news.module.scss";
import hongkong from "Assets/Image/News/Grid/hk-world.jpg";
import hktdc from "Assets/Image/News/Grid/hktdc.jpg";
import miami from "Assets/Image/News/Grid/miami.jpg";
import vicenzaoro from "Assets/Image/News/Grid/vicenza.jpg";
import jgtddubai from "Assets/Image/News/Grid/jgtd-dubai.jpg";
// import jewelleryarabia from "Assets/Image/News/Grid/jewellery-arabia.jpg";
import jmahongkong from "Assets/Image/News/Grid/jma.jpg";
import news2 from "Assets/Image/News/Grid/jck.jpg";
import news3 from "Assets/Image/News/Grid/geneve.jpg";
import news4 from "Assets/Image/News/Grid/iijs.jpg";

const News = () => {
  const newsArr = [
    {
      id: 1,
      slug: "hong-kong-international-diamond-gem-and-pearl-show",
      title: "Arjiv Exports at Hong Kong International Diamond, Gem & Pearl Show 2026",
      image: hktdc,
      alt: "Hong Kong International Diamond, Gem & Pearl Show",
      subtitle: "Arjiv Exports is proud to be exhibiting at the Hong Kong International Diamond, Gem & Pearl Show, one of Asia’s most prestigious sourcing events for diamonds, gems, and pearls. Join us at HKTDC to explore our premium collection."
    },
    {
      id: 2,
      slug: "miami-beach-antique-show",
      title: "Arjiv Exports at Miami Beach Antique Show 2026",
      image: miami,
      alt: "Miami Beach Antique Show 2026",
      subtitle: "Arjiv Exports is excited to participate in the Miami Beach Antique Show 2026, one of the most prestigious events in the USA for antique, vintage, and fine jewellery. Join us at the Miami Beach Convention Center to explore our premium collection of natural, ethically sourced diamonds."
    },
    {
      id: 3,
      slug: "vicenzaoro",
      title: "Visit us at VICENZAORO 2026",
      image: vicenzaoro,
      alt: "Vicenzaoro",
      subtitle: "Arjiv Exports is proud to exhibit at VICENZAORO, one of Europe’s most influential jewellery exhibitions. Held in Vicenza, Italy, this global trade show brings together the world’s most renowned jewellery manufacturers, designers, and diamond suppliers."
    },
    {
      id: 4,
      slug: "iijs-bharat-signature-2026",
      title: "Arjiv Exports at IIJS Bharat - Signature 2026",
      image: news4,
      alt: "IIJS 2026",
      subtitle: "Meet Arjiv Exports at India’s Premier Jewellery Trade Show and the World’s 2nd Largest Gem and Jewellery B2B Show. Join us to explore our exquisite range of natural, ethically sourced diamonds."
    },
    {
      id: 5,
      slug: "jgtd-dubai",
      title: "Arjiv Exports at JGTD Dubai 2025",
      image: jgtddubai,
      alt: "JGTD Dubai - The International B2B Sourcing Event",
      subtitle: "At Arjiv Exports, we see JGTD (Jewellery, Gem & Technology) as a powerful new platform where jewellery, gemstones, and tech innovations converge."
    },
    {
      id: 6,
      slug: "jma-hong-kong",
      title: "Arjiv Exports at JMA 2025 – Hong Kong",
      image: jmahongkong,
      alt: "JMA 2025 - The Most Prestigious Luxury Shopping Event",
      subtitle: "Arjiv Exports is proud to participate in JMA (Hong Kong International Jewellery Show), premier luxury jewellery exhibition."
    },
    // {
    //   id: 2,
    //   slug: "jewellery-arabia",
    //   title: "Arjiv Exports at Jewellery Arabia 2025 – Bahrain",
    //   image: jewelleryarabia,
    //   alt: "Jewellery Arabia - The GCC's Most Prestigious Luxury Shopping Event",
    //   subtitle: "Arjiv Exports is proud to participate in Jewellery Arabia 2025, premier luxury jewellery exhibition."
    // },
    {
      id: 7,
      slug: "jewellery-and-gem-world-hong-kong",
      title: "Arjiv Exports at Jewellery & Gem WORLD Hong Kong Show - 2025",
      image: hongkong,
      alt: "Jewellery & Gem WORLD Hong Kong",
      subtitle: "Arjiv Exports is proud to be exhibiting at Jewellery & Gem WORLD Hong Kong, Asia’s fine jewellery sourcing event in the global jewellery calendar. Join us at HKCEC to explore our premium collection."
    },
    {
      id: 8,
      slug: "jck-las-vegas",
      title: "Arjiv Exports at JCK Las Vegas - International Trade Show 2025",
      image: news2,
      alt: "JCK Las Vegas 2025",
      subtitle: "Visit us at JCK Las Vegas. Whether you're looking for a trusted sourcing partner or unique diamonds for your next jewelry collection, we're here to collaborate and support your brand's growth."
    },
    {
      id: 9,
      slug: "geneva-international-gem-and-jewellery-show",
      title: "Arjiv Exports at Geneva International Gem & Jewellery Show 2025",
      image: news3,
      alt: "Geneva International Gem & Jewellery Show 2025",
      subtitle: "Arjiv Exports is participating in the Geneva International Gem & Jewellery Show. Whether you're a jewellery manufacturer, designer, diamond buyer, or wholesaler, we are here to assist you."
    },
  ];

  // Handle meta tags using useEffect for React 19
  useEffect(() => {
    // Set document title
    document.title = "Latest News & Updates | Arjiv Exports - RJC Certified Diamonds Manufacturer";
    
    // Update meta tags
    const metaTags = [
      {
        name: "description",
        content: "Stay updated with Arjiv Exports' latest news, exhibition participation, industry events, and company announcements from one of India's premier diamond manufacturers."
      },
      {
        property: "og:title", 
        content: "Diamond Industry News & Updates | Arjiv Exports"
      },
      {
        property: "og:description",
        content: "Discover the latest exhibitions, events and company updates from Arjiv Exports, a leading diamond manufacturer focused on quality and innovation."
      },
      {
        property: "og:type",
        content: "website"
      },
      {
        property: "og:url",
        content: "https://www.arjivexports.com/news/"
      },
      {
        property: "og:site_name",
        content: "Arjiv Exports"
      }
    ];

    // Set canonical link
    let canonicalLink = document.querySelector("link[rel='canonical']");
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = "https://www.arjivexports.com/news";

    // Add or update meta tags
    metaTags.forEach(metaInfo => {
      let metaTag = document.querySelector(`meta[${metaInfo.name ? 'name' : 'property'}="${metaInfo.name || metaInfo.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.setAttribute(metaInfo.name ? 'name' : 'property', metaInfo.name || metaInfo.property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute("content", metaInfo.content);
    });

    // Clean up function to potentially restore previous state
    return () => {
      // Cleanup if needed
    };
  }, []);

  return (
    <main className={styles.news}>
      <HeroHeading img={polishing} title="News & Updates" />
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {newsArr.map((news) => (
            <div key={news.id} className="news-card border border-lightGray overflow-hidden shadow-xl">
              <div className="relative">
                {/* 1200 x 628 || 734 X 384 */}
                <Link to={`/news/${news.slug}`}>
                  <img
                    src={news.image}
                    alt={news.alt}
                    className="w-full h-40 md:h-48 lg:h-96 md:object-contain object-cover"
                  />
                </Link>
              </div>
              <div className="p-7">
                <Link to={`/news/${news.slug}`}>
                  <h2 className="text-2xl font-mont font-light text-[#323e78] mb-2 leading-normal">{news.title}</h2>
                </Link>
                <p className="text-sm tracking-wider font-poppins text-600 min-h-[70px]">{news.subtitle}</p>
                <div className="mt-4 border-t border-lightGray pt-4">
                  <Link to={`/news/${news.slug}`} className="text-500 text-sm hover:text-gray-700">
                    Continue Reading →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default News;